import { useMutation, useQueryClient } from '@tanstack/react-query';

import { QUERY_KEYS } from '@hero/constants';
import { automationServices } from '@hero/services';
import { useNotification } from '@hero/store/hooks';

export const useDeleteAutomationOrder = ({ options = {} } = {}) => {
  const queryClient = useQueryClient();
  const { showSuccess } = useNotification();

  return useMutation(({ code, orderCode }) => automationServices.deleteOrder(code, orderCode), {
    onSuccess: () => {
      showSuccess({
        message: 'Successfully deleted the order.',
        type: 'toast'
      });
      queryClient.invalidateQueries({
        queryKey: QUERY_KEYS.useGetAutomationOrders,
        refetchType: 'active'
      });
    },
    ...options
  });
};
